// extracted by mini-css-extract-plugin
module.exports = {"link":"Item_link__1StUL","icon":"Item_icon__avtdn","infoIcon":"Item_infoIcon__1pCOv","centerCell":"Item_centerCell__1oivA","cell":"Item_cell__1J5iD"};